import { action, computed, makeObservable, observable } from 'mobx'

import { CountryItem } from 'components/CountryPhoneInput/CountryPhoneInput'
import { ALL_EXCEPT_NUMBERS_REGEXP } from 'shared/constants/regExp'
import { Country } from 'shared/types/types'

import { countries } from '../../data'
import { PhoneCountryItem } from '../../types'

export class AppCountryPhoneViewModel {
  @observable phone: string = ''
  @observable selectedCountry: PhoneCountryItem = countries[0].value

  constructor() {
    makeObservable(this)
    this.reset()
  }

  @computed
  get phonePrefix() {
    return this.selectedCountry.value
  }

  @computed
  get isValidPhone() {
    if (
      this.selectedCountry.country === Country.BY ||
      this.selectedCountry.country === Country.UZ ||
      this.selectedCountry.country === Country.KG ||
      this.selectedCountry.country === Country.GE ||
      this.selectedCountry.country === Country.TJ
    ) {
      return this.fullPhone.toString().length === 12
    } else {
      return this.fullPhone.toString().length === 11
    }
  }

  @computed
  get fullPhone() {
    return Number(`${this.phonePrefix}${this.phone}`)
  }

  @action
  setPhone = (value: string) => {
    this.phone = value.replace(ALL_EXCEPT_NUMBERS_REGEXP, '')
  }

  @action
  setSelectedCountry = (value: CountryItem) => {
    this.selectedCountry = value
    this.phone = ''
  }

  @action
  reset = () => {
    this.selectedCountry = countries[0].value
    this.phone = ''
  }
}
